export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line', description: '浏览所有国产原创视频内容' },
  { slug: 'drama', name: '剧情', icon: 'ri-movie-line', description: '引人入胜的国产剧情片与电视剧' },
  { slug: 'comedy', name: '喜剧', icon: 'ri-emotion-laugh-line', description: '幽默风趣的国产喜剧作品' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-camera-line', description: '真实记录中国的纪录片佳作' },
  { slug: 'tech', name: '科技', icon: 'ri-cpu-line', description: '前沿科技与创新内容' },
  { slug: 'culture', name: '文化', icon: 'ri-ancient-gate-line', description: '传承与创新的文化类视频' },
  { slug: 'shortfilm', name: '短片', icon: 'ri-film-line', description: '创意十足的原创短片' },
  { slug: 'animation', name: '动画', icon: 'ri-paint-brush-line', description: '国产原创动画作品' },
];

export const featuredVideos = [
  {
    id: 'mountains-call',
    title: '大山深处的呼唤',
    category: 'drama',
    categoryName: '剧情',
    duration: '1小时32分',
    year: '2025',
    director: '张明远',
    rating: 9.2,
    description: '一个关于坚守与传承的故事。在云南深山的彝族村落里，一位老教师用三十年光阴守护着村里唯一的小学，当年轻一代面临去留抉择时，大山深处响起了时代的回响。',
    tags: ['乡村振兴', '教育', '温情'],
  },
  {
    id: 'tech-future',
    title: '未来已来：中国AI创新之路',
    category: 'tech',
    categoryName: '科技',
    duration: '48分钟',
    year: '2026',
    director: '陈思远',
    rating: 8.9,
    description: '深度探访中国人工智能领域的创新力量，从实验室到产业应用，记录中国科技工作者在AI领域的突破与探索。',
    tags: ['人工智能', '科技创新', '产业升级'],
  },
  {
    id: 'city-laugh',
    title: '城市笑传',
    category: 'comedy',
    categoryName: '喜剧',
    duration: '1小时15分',
    year: '2025',
    director: '刘欢',
    rating: 8.7,
    description: '都市职场轻喜剧，讲述四个年轻人在大城市打拼的爆笑日常，用幽默化解生活压力，在笑声中寻找人生的答案。',
    tags: ['都市', '职场', '轻喜剧'],
  },
  {
    id: 'silk-road',
    title: '丝路新语',
    category: 'documentary',
    categoryName: '纪录片',
    duration: '1小时50分',
    year: '2026',
    director: '王立群',
    rating: 9.5,
    description: '沿着古丝绸之路，记录从西安到喀什的现代变迁。八位不同身份的主人公，讲述丝绸之路经济带上的中国故事。',
    tags: ['历史', '一带一路', '文化传承'],
  },
  {
    id: 'ink-soul',
    title: '水墨魂',
    category: 'animation',
    categoryName: '动画',
    duration: '42分钟',
    year: '2026',
    director: '林青',
    rating: 9.0,
    description: '以中国传统水墨画风格呈现的动画短片集，将古典诗词意境与现代动画技术完美融合，展现东方美学的独特魅力。',
    tags: ['水墨动画', '传统文化', '艺术'],
  },
  {
    id: 'taste-home',
    title: '舌尖上的家',
    category: 'culture',
    categoryName: '文化',
    duration: '55分钟',
    year: '2025',
    director: '赵小华',
    rating: 8.8,
    description: '走进中国各地的家庭厨房，记录普通人的美食故事。每一道家常菜背后，都藏着一个关于家与爱的温暖记忆。',
    tags: ['美食', '家庭', '民俗'],
  },
];

export const popularVideos = [
  {
    id: 'cyber-dream',
    title: '赛博梦华录',
    category: 'shortfilm',
    categoryName: '短片',
    duration: '18分钟',
    year: '2026',
    director: '周星辰',
    rating: 9.1,
    views: '128万',
    description: '将宋代美学与赛博朋克风格大胆融合，在霓虹闪烁的虚拟开封府中，展开一场关于传统与未来的视觉实验。',
    tags: ['实验短片', '赛博朋克', '国风'],
  },
  {
    id: 'grandma-recipe',
    title: '奶奶的食谱',
    category: 'culture',
    categoryName: '文化',
    duration: '35分钟',
    year: '2025',
    director: '吴美玲',
    rating: 9.3,
    views: '256万',
    description: '跟随六位不同地域的奶奶，学习她们珍藏一生的拿手菜。在炊烟袅袅中，品味中国家庭最本真的味道。',
    tags: ['美食', '家庭记忆', '民俗'],
  },
  {
    id: 'dawn-patrol',
    title: '黎明前的巡逻',
    category: 'documentary',
    categoryName: '纪录片',
    duration: '62分钟',
    year: '2026',
    director: '刘建华',
    rating: 9.4,
    views: '89万',
    description: '跟随中国维和部队在非洲的日常巡逻，记录中国军人在国际维和行动中的坚守与担当，展现大国责任。',
    tags: ['军事', '维和', '纪实'],
  },
  {
    id: 'love-letter',
    title: '给未来的情书',
    category: 'drama',
    categoryName: '剧情',
    duration: '1小时28分',
    year: '2025',
    director: '林小雨',
    rating: 8.7,
    views: '345万',
    description: '跨越二十年的爱情故事，从手写信到微信语音，记录中国式爱情的变迁。在快节奏的时代，总有一个人值得慢慢等待。',
    tags: ['爱情', '时代变迁', '温情'],
  },
  {
    id: 'robot-xiao',
    title: '机器小肖',
    category: 'tech',
    categoryName: '科技',
    duration: '28分钟',
    year: '2026',
    director: '黄明',
    rating: 8.6,
    views: '198万',
    description: '一位深圳硬件工程师的创业故事，从华强北的电子市场到全球消费电子舞台，中国智造正在改变世界的生活方式。',
    tags: ['创业', '智能制造', '深圳'],
  },
  {
    id: 'opera-reborn',
    title: '戏韵新生',
    category: 'culture',
    categoryName: '文化',
    duration: '45分钟',
    year: '2026',
    director: '杨艺',
    rating: 9.0,
    views: '167万',
    description: '当昆曲遇上电子音乐，当京剧脸谱走进数字艺术。一群年轻艺术家用全新的方式诠释中国传统戏曲，古老艺术在当代焕发新生。',
    tags: ['戏曲', '创新', '国潮'],
  },
  {
    id: 'grassland-song',
    title: '草原上的歌',
    category: 'documentary',
    categoryName: '纪录片',
    duration: '72分钟',
    year: '2025',
    director: '巴特尔',
    rating: 9.2,
    views: '112万',
    description: '记录内蒙古草原上最后一批游牧民族的生活变迁，在现代化浪潮中，他们如何守护祖先留下的草原与歌声。',
    tags: ['民族', '草原', '人文'],
  },
  {
    id: 'code-breaker',
    title: '密码破译者',
    category: 'drama',
    categoryName: '剧情',
    duration: '1小时40分',
    year: '2026',
    director: '孙正阳',
    rating: 8.9,
    views: '289万',
    description: '抗战时期密码战的惊险故事，中国密码学家与日军斗智斗勇，用智慧守护国家机密。紧张刺激的谍战推理之作。',
    tags: ['谍战', '历史', '悬疑'],
  },
];

export const stats = [
  { value: '50,000+', label: '优质视频资源' },
  { value: '3,200+', label: '原创作者入驻' },
  { value: '800万+', label: '月活跃用户' },
  { value: '98%', label: '用户好评率' },
];

export const faqs = [
  {
    question: '国产视频精选平台的内容来源是什么？',
    answer: '我们平台所有内容均来自国内原创作者和正规影视制作机构的正版授权，涵盖独立创作者短片、专业影视公司作品以及纪录片制作团队的精品内容。我们严格审核每一部上线作品，确保内容质量和版权合规。',
  },
  {
    question: '如何在平台上传自己的原创视频作品？',
    answer: '创作者可以通过注册成为认证作者后上传原创作品。提交后我们的编辑团队会在3个工作日内完成审核，审核通过后作品即可在平台展示。我们为优秀原创作者提供流量扶持和创作激励计划。',
  },
  {
    question: '平台支持哪些视频类型和格式？',
    answer: '我们支持剧情片、纪录片、动画、短片、喜剧、科技、文化等多种类型。视频格式方面支持MP4、MOV、AVI等主流格式，建议上传1080P及以上分辨率的视频以获得最佳观看体验。',
  },
  {
    question: '观看视频需要付费吗？',
    answer: '平台大部分内容免费观看，部分精选优质长片和独家内容采用会员制观看模式。我们提供灵活的会员方案，月费仅需15元起，即可畅享全部付费内容。同时不定期推出免费观影活动。',
  },
  {
    question: '如何联系平台客服？',
    answer: '您可以通过「关于我们」页面的联系方式与我们取得联系，或发送邮件至 hello@guochanvideo.com。我们的客服团队工作时间为周一至周日 9:00-21:00，节假日正常服务。',
  },
  {
    question: '平台对原创作者有哪些支持政策？',
    answer: '我们为原创作者提供多维度的支持：包括但不限于创作基金资助、专业设备租赁优惠、后期制作资源对接、行业导师指导计划以及定期的创作者交流活动。优秀作品还将获得平台首页推荐和社交媒体推广资源。',
  },
];